module.exports = __webpack_public_path__ + "static/media/nissan-provider.675c797f.svg";